import { cmsServiceFactory } from './cms';
import { emailServiceFactory } from './email';
import { applyServiceFactory } from './apply';

export const service = {
  cmsService: cmsServiceFactory(),
  emailService: emailServiceFactory(),
  applyService: applyServiceFactory()
};
